import React from 'react';
import {Link} from "react-router";

class Panel extends React.Component {
    constructor(props){
        super(props);
        var defState = {
            hidden: false
        };
        if(props.hidden)
        {
            defState.hidden = props.hidden;
        }
        this.state = defState;
    }
	render(){
        const sizes = {
            "third": "col-md-4 col-sm-4 col-xs-4",
            "half": "col-md-6 col-sm-6 col-xs-6",
            "halfFull": "col-md-6 col-sm-6 col-xs-12",
            "custom": "col-md-" + this.props.custom + " col-sm-" + this.props.custom + " col-xs-" + this.props.custom,
            "custom2": "col-md-" + this.props.custom + " col-sm-" + this.props.custom + " col-xs-12",
            "custom3": "col-md-" + this.props.custom + " col-sm-12 col-xs-12"
        }
        var sizeClass = sizes[this.props.size] ? sizes[this.props.size] : "col-md-12 col-sm-12 col-xs-12";
		return (<div className={sizeClass + " panelCont"}>
    <div className="x_panel" style={this.props.panelStyle}>
        <div className="x_title">
            <h2>{this.props.title}</h2>

            <ul className="nav navbar-right panel_toolbox">
                {
                    this.props.customIcons2 ? this.props.customIcons2() : null
                }
                {
                    this.props.customIcons ? this.props.customIcons() : null
                }
                <li>{this.props.add ? <Link to={this.props.add} onClick={this.props.onAdd}><i className="fa fa-plus"></i></Link> : "" }
                    </li>
                    <li>
                    <a className="collapse-link" onClick={() => this.setState({hidden: !this.state.hidden})}>
                        <i className={this.state.hidden ? "fa fa-chevron-down" : "fa fa-chevron-up"}></i>
                    </a>
                    </li>
                    </ul>
                    <div className="clearfix"></div>
                </div>

                <div className="x_content" style={this.state.hidden ? {display: "none"} : {}}>
                	{this.props.children}
                </div>
            </div>
        </div>);
	}
}

export default Panel;


// WEBPACK FOOTER //
// ./src/components/Panel.js